module.exports = __webpack_public_path__ + "img/wuxi_s.5e7328c.png";